import moment from "moment-timezone";

export interface ITimeZone {
	name: string;
	displayName: string;
	offset: number;
}
export interface ICustomTimezone {
	[key: string]: string;
}

export const HIDE_ERROR_TIMEOUT = 3000;
export const HIDE_SUCCESS_TIMEOUT = 1000;
export const MILLISECONDS_OF_SECOND = 1000;
export const MILLISECONDS_OF_MIN = 60000;
export const MILLISECONDS_OF_5MIN = 300000;
export const MILLISECONDS_OF_HOUR = 3600000;
export const HOURS_OF_DAY = 24;
export const DAYS_OF_WEEK = 7;
export const _4WEEK = 4;
export const MILLISECONDS_OF_4WEEK = _4WEEK * DAYS_OF_WEEK * HOURS_OF_DAY * MILLISECONDS_OF_HOUR;

export const getTz = (): string => localStorage.getItem("SENDUM_CORE_TZ") || moment.tz.guess(true);

export const getTzOffset = (): number => (moment.tz.zone(getTz())?.parse(moment().valueOf()) || 0);

export const getTzString = (zoneName: string = getTz(), timestamp: number = moment().valueOf()): ITimeZone | null => {
	const zone = moment.tz.zone(zoneName);
	if (zone !== null) {
		const min: number = -zone.parse(timestamp);
		const hr = `${Math.round(min / 60)}:${min % 60 === 0 ? "00" : Math.abs(min % 60)}`;
		const name: string = `${zoneName.includes("Etc/") ? zoneName : zoneName.split("/")[1] ?? zoneName}`;

		return {
			name: zoneName,
			displayName: `(GMT${hr.includes("-") ? hr : `+${hr}`}) ${name}`,
			offset: zone.parse(timestamp),
		};
	}

	return null;
};

export const setTz = (tz: string): void => {
	localStorage.setItem("SENDUM_CORE_TZ", tz);
	window.location.reload();
};

export const format = (epoch: number, _format = "lll", withTz?: boolean): string => {
	const tz = getTz();

	return `${moment(epoch).tz(tz).format(_format)}${withTz ? " " + moment.tz(tz).zoneName() : ""}`;
};

export const current = (): number => moment().valueOf();

export const formatUTC = (epoch: number, _format = "lll"): string => moment.utc(epoch).format(_format);


export const timeZones = (): (ITimeZone | null)[] => {
	const timestamp = moment().valueOf();

	return moment.tz.names()
		.map(zoneName => getTzString(zoneName, timestamp))
		.filter(item => item !== null)
		.sort((a, b) => (a === null || b === null ? 0 : b.offset - a.offset));
};

export const printMinutes = (mins?: number): string => {
	if (mins === undefined || isNaN(mins)) {
		return "";
	}

	return `${Math.trunc(mins / 60)}:${mins - Math.trunc(mins / 60) * 60}`;
};

export const toDateTimePicker = (epoch: number, tz: string): Date | undefined => {
    if (!epoch || !tz) {
        return undefined
    }
    const epochToZone = moment.tz(epoch, tz)
    return new Date(moment(epochToZone.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm').valueOf())
}

export const fromDateTimePicker = (date: Date, tz: string): number => {
    const json = {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes()
    }
    return moment.tz(json, tz).valueOf()
}
